import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "./LanguageContext";
import styled from "styled-components";


const Footer = () => {
  const { lang, t } = useLanguage();
  return (
  <FooterWrap>
    <Top>
      <Brand>
        SWING<span style={{ color: "#4CAF50" }}>MENTOR</span>
      </Brand>
      <TagLine>{t("footer.tagline")}</TagLine>
    </Top>

    <Divider />

    <Grid>
      <Col>
        <ColHead>{t("footer.product")}</ColHead>
        <FooterLink as={Link} to="/">{t("nav.home")}</FooterLink>
        <FooterLink as={Link} to="/premium">{t("nav.premium")}</FooterLink>
        <FooterLink as={Link} to="/about">{t("nav.about")}</FooterLink>
      </Col>
      <Col>
        <ColHead>{t("footer.social")}</ColHead>
        <FooterLink href="https://instagram.com/swingmentor" target="_blank" rel="noopener">Instagram</FooterLink>
        <FooterLink href="https://linkedin.com/company/swingmentor" target="_blank" rel="noopener">LinkedIn</FooterLink>
        <FooterLink href="https://youtube.com/swingmentor" target="_blank" rel="noopener">YouTube</FooterLink>
      </Col>
      <Col>
        <ColHead>{t("footer.legal")}</ColHead>
        <FooterLink as={Link} to={lang === "en" ? "/legal/terms-en"   : "/legal/terms"}>{t("footer.terms")}</FooterLink>
        <FooterLink as={Link} to={lang === "en" ? "/legal/privacy-en" : "/legal/privacy"}>{t("footer.privacy")}</FooterLink>
        <FooterLink as={Link} to={lang === "en" ? "/legal/consent-en" : "/legal/consent"}>{t("footer.consent")}</FooterLink>
      </Col>
      <Col>
        <ColHead>{t("footer.contacts")}</ColHead>
        <FooterLink href="mailto:info@swingmentor.pro">
          info@swingmentor.pro
        </FooterLink>
      </Col>
    </Grid>

    <Divider />

    <Bottom>
      <Copy>© {new Date().getFullYear()} SwingMentor. {t("footer.rights")}</Copy>
      <GreenDot />
    </Bottom>
  </FooterWrap>
  );
};

const FooterWrap = styled.footer`
  background: #f5f5f5;
  border-top: 1px solid rgba(0,0,0,0.08);
  padding: 4rem 6vw 2.5rem;
  font-family: 'Montserrat', sans-serif;
  color: #111;
`;

const Top = styled.div`
  margin-bottom: 2.5rem;
`;

const Brand = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 0.35rem;
`;

const TagLine = styled.p`
  margin: 0;
  font-size: 0.85rem;
  color: rgba(0,0,0,0.4);
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid rgba(0,0,0,0.08);
  margin: 0 0 2rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  margin-bottom: 2rem;

  @media (max-width: 760px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

const ColHead = styled.div`
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: rgba(0,0,0,0.35);
  margin-bottom: 0.25rem;
`;

const FooterLink = styled.a`
  font-size: 0.88rem;
  color: rgba(0,0,0,0.65);
  text-decoration: none;
  transition: color 0.2s;

  &:hover { color: #4CAF50; }
`;

const Bottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Copy = styled.div`
  font-size: 0.75rem;
  color: rgba(0,0,0,0.35);
`;

const GreenDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4CAF50;
  box-shadow: 0 0 8px #4CAF50;
`;

export default Footer;
